(function () {
  if (window.__obersonExactSizeSort) return;
  window.__obersonExactSizeSort = true;

  const SIZE_LABELS = [
    'taille',
    'tailles',
    'taille us',
    'tailles us',
    'size',
    'sizes',
    'us size',
    'us sizes',
    'grandeur',
    'grandeurs',
    'pointure',
    'pointures'
  ];

  const ALPHA_ORDER = {
    xxxs: 1,
    xxs: 2,
    xs: 3,
    s: 4,
    m: 5,
    l: 6,
    xl: 7,
    xxl: 8,
    xxxl: 9
  };

  function normalize(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/,/g, '.')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeCompact(value) {
    return normalize(value).replace(/\s+/g, '');
  }

  function isSizeOption(name) {
    const n = normalize(name);
    return SIZE_LABELS.some(label => n.includes(label));
  }

  function getSortMeta(rawValue) {
    const value = normalizeCompact(rawValue);

    if (!value) return { type: 99, order: 9999 };

    if (ALPHA_ORDER[value] !== undefined) {
      return { type: 1, order: ALPHA_ORDER[value] };
    }

    if (
      value === 'onesize' ||
      value === 'one-size' ||
      value === 'unique' ||
      value === 'tailleunique'
    ) {
      return { type: 2, order: 1 };
    }

    if (/^\d+(\.\d+)?$/.test(value)) {
      return { type: 0, order: parseFloat(value) };
    }

    const match = value.match(/^(\d+(\.\d+)?)(c|y|k|w)$/);
    if (match) {
      const base = parseFloat(match[1]);
      const suffix = match[3];
      const suffixRank = { c: 1, y: 2, k: 3, w: 4 }[suffix] || 9;
      return { type: 3, order: base + (suffixRank / 100) };
    }

    return { type: 99, order: 9999 };
  }

  function compareItems(a, b) {
    if (a.meta.type !== b.meta.type) {
      return a.meta.type - b.meta.type;
    }

    if (a.meta.order < b.meta.order) return -1;
    if (a.meta.order > b.meta.order) return 1;

    return 0;
  }

  function getOptionName(fieldset) {
    const firstSpan = fieldset.querySelector('.product-form__option-label span');
    if (firstSpan && firstSpan.textContent.trim()) {
      return firstSpan.textContent.trim();
    }

    const input = fieldset.querySelector('input[data-option-name]');
    if (input) {
      return input.getAttribute('data-option-name') || '';
    }

    return '';
  }

  function sortOneFieldset(fieldset) {
    const optionName = getOptionName(fieldset);
    if (!isSizeOption(optionName)) return;

    const container = fieldset.querySelector('.swatches__size-swatches, .swatches__swatches');
    if (!container) return;

    const swatches = Array.from(container.querySelectorAll(':scope > label.swatches__swatch'));
    if (swatches.length < 2) return;

    const items = swatches.map((swatch) => {
      const input = swatch.querySelector('input');
      const value =
        (input && input.value) ||
        swatch.querySelector('.swatches__text-value')?.textContent ||
        swatch.textContent ||
        '';

      return {
        el: swatch,
        value: value.trim(),
        meta: getSortMeta(value)
      };
    });

    const before = items.map(item => normalizeCompact(item.value));
    const sorted = [...items].sort(compareItems);
    const after = sorted.map(item => normalizeCompact(item.value));

    const sameOrder = before.every((value, index) => value === after[index]);
    if (sameOrder) return;

    sorted.forEach(item => {
      container.appendChild(item.el);
    });
  }

  function runSort(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const fieldsets = scope.querySelectorAll('.product-form__options fieldset.product-form__option[data-option-container]');
    fieldsets.forEach(sortOneFieldset);
  }

  let rafId = null;
  function scheduleSort(root) {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      runSort(root || document);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleSort(document);
  });

  window.addEventListener('load', function () {
    scheduleSort(document);
  });

  document.addEventListener('change', function (event) {
    const fieldset = event.target.closest('.product-form__options fieldset.product-form__option');
    if (fieldset) {
      setTimeout(function () { scheduleSort(document); }, 10);
      setTimeout(function () { scheduleSort(document); }, 100);
      setTimeout(function () { scheduleSort(document); }, 300);
    }
  });

  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
        scheduleSort(document);
        break;
      }
    }
  });

  const optionsRoot = document.querySelector('.product-form__options') || document.body;
  observer.observe(optionsRoot, {
    childList: true,
    subtree: true
  });

  setTimeout(function () { scheduleSort(document); }, 50);
  setTimeout(function () { scheduleSort(document); }, 250);
  setTimeout(function () { scheduleSort(document); }, 700);
})();